import {
  CustomTableCell,
  CustomTableHead,
  FormDatePicker,
  FormInput,
  FormSectionHeader,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Label,
  Switch,
  Table,
  TableBody,
  TableHeader,
  TableRow,
} from "@/components/ui";
import {
  BILLING_AMOUNT,
  BILLING_DATE,
  BILLING_MONTH_YEAR,
  COMMENT,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  ITEM_TEXT,
  LINE_BILLING_AMOUNT,
  LINE_ITEMS,
  PAYMENT_TERM,
  TRANSACTION_TYPE,
  DOCUMENT_ID,
  LINE_ITEM_TYPE,
  GL_ACCOUNT,
  PROPERTY_ID,
  BILLING_CATEGORY,
  PROPERTY_MODEL,
  PROPERTY_BLOCK,
  UNIT_NO,
  STREET_ADDRESS,
  CURR_OWNER_ID,
  CURR_OWNER_LAST_NAME,
  PROPERTY_NAME,
} from "./consts";
import { cn, transactionTypeOptions } from "@/lib/utils";

const AddEdit = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    requiredFields,
    isDocumentTypeLoading,
    isLoadingGlMaster,
    breadcrumbTitle,
    keys,
    documentTypes,
    isPaymentTermLoading,
    paymentTermOptions,
    isPropertyModelLoading,
    glData,
    isPropertyBlockLoading,
    isBillingCategoryLoading,
    onCancel,
    isLoadingBillingData,
    isLoadingProperties,
    isEntryView,
    setIsEntryView,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6 !pt-0">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading
          title={breadcrumbTitle}
          breadcrumbData={breadcrumbData}
          showBack
          onBackClick={onBackClick}
        />
      </div>

      {isLoadingGlMaster ||
      isDocumentTypeLoading ||
      isPaymentTermLoading ||
      isPropertyModelLoading ||
      isPropertyBlockLoading ||
      isBillingCategoryLoading ||
      isLoadingBillingData ||
      isLoadingProperties ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form>
            <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[15px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] items-center">
                <FormSectionHeader>Document Header</FormSectionHeader>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-[20px]">
                <FormSelect
                  key={keys.documentTypes}
                  name={DOCUMENT_TYPE}
                  control={form.control}
                  label="Document Type"
                  placeholder="Please select"
                  error={errors[DOCUMENT_TYPE]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_TYPE)}
                  options={(documentTypes || [])?.map((data: any) => ({
                    value: data?.documentTypeId?.toString(),
                    label: data?.documentType,
                  }))}
                  disabled
                />
                <FormInput
                  name={DOCUMENT_ID}
                  control={form.control}
                  label="Document Id"
                  placeholder="Please enter"
                  error={errors[DOCUMENT_ID]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_ID)}
                  disabled
                />
                <FormInput
                  name={BILLING_MONTH_YEAR}
                  control={form.control}
                  label="Billing Month/Year"
                  placeholder="Select"
                  error={errors[BILLING_MONTH_YEAR]?.message}
                  isRequired={requiredFields.includes(BILLING_MONTH_YEAR)}
                  disabled
                />

                <FormDatePicker
                  name={BILLING_DATE}
                  control={form.control}
                  label="Posting Date"
                  placeholder="Please select"
                  error={errors[BILLING_DATE]?.message}
                  isRequired
                  disabled
                />
                <FormInput
                  name={BILLING_AMOUNT}
                  control={form.control}
                  label="Billing Amount"
                  placeholder="Please enter"
                  error={errors[BILLING_AMOUNT]?.message}
                  isRequired={requiredFields.includes(BILLING_AMOUNT)}
                  disabled
                  startIcon="$"
                  variant="float"
                />
                <FormDatePicker
                  name={DUE_DATE}
                  control={form.control}
                  label="Due Date"
                  placeholder="Please select"
                  error={errors[DUE_DATE]?.message}
                  isRequired={requiredFields.includes(DUE_DATE)}
                  disabled
                />
                <FormSelect
                  key={keys.transactionType}
                  name={TRANSACTION_TYPE}
                  control={form.control}
                  label="Transaction Type"
                  placeholder="Please select"
                  error={errors[TRANSACTION_TYPE]?.message}
                  isRequired={requiredFields.includes(TRANSACTION_TYPE)}
                  options={transactionTypeOptions}
                  disabled
                />
                {/* <FormSelect
                  key={keys.accountName}
                  name={GL_ACCOUNT}
                  control={form.control}
                  label="Gl Account"
                  placeholder="Please select"
                  error={errors[GL_ACCOUNT]?.message}
                  isRequired={requiredFields.includes(GL_ACCOUNT)}
                  options={(glData?.data || [])
                    ?.sort((a: any, b: any) =>
                      a.glAccountNumber?.localeCompare(b.glAccountNumber)
                    )
                    ?.map((data: any) => {
                      return {
                        label: `${data?.glAccountNumber} - ${data?.accountShortDesc}`,
                        value: data?.glMasterId?.toString(),
                      };
                    })}
                  disabled
                /> */}
                <FormInput
                  key={keys.paymentTerm}
                  name={PAYMENT_TERM}
                  control={form.control}
                  label="Payment Term"
                  placeholder="Please select"
                  error={errors[PAYMENT_TERM]?.message}
                  isRequired={requiredFields.includes(PAYMENT_TERM)}
                  options={(paymentTermOptions?.data || [])?.map(
                    (data: any) => ({
                      label: data?.paymentTermName,
                      value: data?.paymentTermId?.toString(),
                    })
                  )}
                  disabled
                />
                <FormInput
                  name={COMMENT}
                  control={form.control}
                  label="Header Text"
                  placeholder="Please enter"
                  error={errors[COMMENT]?.message}
                  isRequired={requiredFields.includes(COMMENT)}
                  disabled
                />
              </div>
            </div>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[15px]">
            <div className="flex flex-row items-center justify-between">
                <FormSectionHeader className="mb-0">Line Items</FormSectionHeader>
                <div className="flex items-center justify-end gap-2 h-[38px] mb-5">
                  <Label className="text-[10px]">GL View</Label>
                  <Switch 
                    checked={isEntryView}
                    onCheckedChange={setIsEntryView}
                  />
                  <Label className="text-[10px]">Entry View</Label>
                </div>
              </div>

              <div className="overflow-x-auto w-full">
                <div className={cn(isEntryView ? "min-w-[2000px]" : "min-w-[800px]")}>
                  <Table>
                    <TableHeader>
                      <TableRow className="mb-3 rounded">
                        {isEntryView ? <>
                          <CustomTableHead className="w-[150px]">
                            Property ID
                          </CustomTableHead>
                          <CustomTableHead className="w-[150px]">
                            Property Name
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Billing Category
                          </CustomTableHead>
                          <CustomTableHead className="w-[150px]">
                            Prop Model
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Prop Block
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Unit No.
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Street Address
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Curr. Owner ID
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Cur. Owner Last Name
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Dr/Cr
                          </CustomTableHead>
                          <CustomTableHead className="w-[100px]">
                            Billing Amt.
                          </CustomTableHead>
                        </> :
                        <>
                          <CustomTableHead className="w-[50px]">
                            GL Account
                          </CustomTableHead>
                          <CustomTableHead className="w-[50px]">
                            Dr/Cr
                          </CustomTableHead>
                          <CustomTableHead className="w-[60px]">
                            Billing Amt.
                          </CustomTableHead>
                          <CustomTableHead className="w-[150px]">
                            Line Item Text
                          </CustomTableHead>
                        </>}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {form.watch(LINE_ITEMS)?.map((_: any, index: number) => {
                        const isOffset = _?.[LINE_ITEM_TYPE]?.toLowerCase() == "offset";
                        if (isOffset && isEntryView) return;

                        return (
                          <TableRow
                            key={`row-${index}`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            {
                              isEntryView ?
                              <>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${PROPERTY_ID}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        PROPERTY_ID
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${PROPERTY_ID}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${PROPERTY_NAME}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        PROPERTY_NAME
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${PROPERTY_NAME}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    key={keys.billingCategory}
                                    name={`${LINE_ITEMS}.${index}.${BILLING_CATEGORY}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        BILLING_CATEGORY
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${BILLING_CATEGORY}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    key={keys.propertyModel}
                                    name={`${LINE_ITEMS}.${index}.${PROPERTY_MODEL}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        PROPERTY_MODEL
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${PROPERTY_MODEL}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${PROPERTY_BLOCK}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        PROPERTY_BLOCK
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${PROPERTY_BLOCK}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${UNIT_NO}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        UNIT_NO
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${UNIT_NO}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${STREET_ADDRESS}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        STREET_ADDRESS
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${STREET_ADDRESS}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${CURR_OWNER_ID}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        CURR_OWNER_ID
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${CURR_OWNER_ID}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${CURR_OWNER_LAST_NAME}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        CURR_OWNER_LAST_NAME
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${CURR_OWNER_LAST_NAME}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${DRCR}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        DRCR
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${DRCR}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${LINE_BILLING_AMOUNT}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        LINE_BILLING_AMOUNT
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${LINE_BILLING_AMOUNT}`
                                    )}
                                    disabled
                                    startIcon="$"
                                    variant="float"
                                  />
                                </CustomTableCell>
                              </>
                              : <>
                                <CustomTableCell>
                                  <FormSelect
                                    key={keys.accountName}
                                    name={`${LINE_ITEMS}.${index}.${GL_ACCOUNT}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Please select"
                                    error={(errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                      GL_ACCOUNT
                                    ]?.message}
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${GL_ACCOUNT}`
                                    )}
                                    options={(glData?.data || [])
                                      ?.sort((a: any, b: any) =>
                                        a.glAccountNumber?.localeCompare(b.glAccountNumber)
                                      )
                                      ?.map((data: any) => {
                                        return {
                                          label: `${data?.glAccountNumber} - ${data?.accountShortDesc}`,
                                          value: data?.glMasterId?.toString(),
                                        };
                                      })}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${DRCR}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        DRCR
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${DRCR}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${LINE_BILLING_AMOUNT}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        LINE_BILLING_AMOUNT
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${LINE_BILLING_AMOUNT}`
                                    )}
                                    disabled
                                    startIcon="$"
                                    variant="float"
                                  />
                                </CustomTableCell>
                                <CustomTableCell>
                                  <FormInput
                                    name={`${LINE_ITEMS}.${index}.${ITEM_TEXT}`}
                                    control={form.control}
                                    label=""
                                    placeholder="Enter"
                                    error={
                                      (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                        ITEM_TEXT
                                      ]?.message
                                    }
                                    isRequired={requiredFields.includes(
                                      `${LINE_ITEMS}.${index}.${ITEM_TEXT}`
                                    )}
                                    disabled
                                  />
                                </CustomTableCell>
                              </>}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3  py-3">
              <Button variant="outline" type="button" onClick={onCancel}>
                Cancel
              </Button>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default AddEdit;
